import type { DesignElement, DesignElementType } from '@/types/blocks'
import { createDesignElement, newBadgeItem, newTableCell } from './designElementDefaults'

// Картинка из курса «Китайский чай» — настоящий пример автора.
const SAMPLE_IMAGE =
  'https://s3-academy.crypton.xyz/media/251b41de-5de2-42a7-8a35-46286718be6f.webp'

// Пример заполнен на ОБОИХ языках: холст показывает строго язык правки, и
// на английском русский пример давал пустые прочерки и русские подсказки.
const row = (cells: [string, string][]) =>
  cells.map(([ru, en]) => ({ ...newTableCell(ru), contentEn: en }))

// Бейдж с иконкой из каталога (`iconCatalog`), как его собирает автор в панели.
const badge = (text: string, textEn: string, icon: string) => ({
  ...newBadgeItem(text),
  textEn,
  iconType: 'lucide' as const,
  iconValue: icon,
})

/**
 * Элемент составного блока с примерными данными — для ПРИМЕРКИ на холсте, когда
 * автор наводит мышь на тип в панели. В черновик не попадает: добавляется всегда
 * элемент по умолчанию (`createDesignElement`).
 */
export const sampleDesignElement = (type: DesignElementType): DesignElement => {
  switch (type) {
    case 'heading':
      return {
        ...createDesignElement('heading'),
        content: 'Как заварить улун',
        contentEn: 'How to brew oolong',
      }
    case 'text':
      // Подложка и выделения — те же приёмы, что даёт автору панель текста.
      return {
        ...createDesignElement('text'),
        backdrop: 'light',
        content:
          'Прогрейте посуду, засыпьте <mark>5–7 г листа</mark> и заваривайте <strong>по 10–20 секунд</strong>, с каждым проливом чуть дольше.',
        contentEn:
          'Warm the teaware, add <mark>5–7 g of leaves</mark> and steep <strong>for 10–20 seconds</strong>, a little longer with each infusion.',
      }
    case 'image':
      return { ...createDesignElement('image'), imageUrl: SAMPLE_IMAGE, imageUrlEn: SAMPLE_IMAGE }
    case 'badge':
      return {
        ...createDesignElement('badge'),
        badges: [
          badge('Зелёный', 'Green', 'Leaf'),
          badge('Улун', 'Oolong', 'Mountain'),
          badge('Красный', 'Black', 'Flame'),
        ],
      }
    case 'table':
      return {
        ...createDesignElement('table'),
        tableData: [
          row([
            ['Чай', 'Tea'],
            ['Температура', 'Temperature'],
          ]),
          row([
            ['Зелёный', 'Green'],
            ['80 °C', '80 °C'],
          ]),
          row([
            ['Улун', 'Oolong'],
            ['90 °C', '90 °C'],
          ]),
          row([
            ['Красный', 'Black'],
            ['95 °C', '95 °C'],
          ]),
        ],
      }
  }
}
